module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.128c3c68.ttf";